Namespace 'Common.SimpleTabs'

class Common.SimpleTabs.SimpleTabContentView extends Backbone.View
  className: 'tab-pane'
  attributes:
    role: 'tabpanel'

  initialize: ({tab}) ->
    @tab = tab

  render: ->
    @$el.addClass "#{@tab.id}-tab-content"
    @$el.attr 'id', @tab.id
    @$el.empty().append @tab.contentView.el
    @

  activate: ->
    @$el.addClass 'active'
